import { useEffect, useState } from "react";
import { useSettings } from "../useSettings";
import iconBangKeo from "./assets/mi-bangkeo.svg";
import iconTiLe from "./assets/mi-ti-le.svg";
import iconKiemTien from "./assets/mi-dudoan-kiemtien-gold.svg";
import iconNhanDinh from "./assets/mi-nhandinh.svg";
import iconNews from "./assets/news-icon.svg";
import iconHighlight from "./assets/event-highlight.svg";
import iconTipThu from "./assets/mi-tipthu.svg";
import "./header-desktop-menu.css";

const ICON_FILTER_ACTIVE =
  "brightness(0) saturate(100%) invert(67%) sepia(95%) saturate(1352%) hue-rotate(1deg) brightness(101%) contrast(101%)";
const ICON_FILTER_IDLE = "brightness(0) saturate(100%) invert(100%) opacity(0.85)";

const MENU = [
  { id: "bangkeo", label: "Bảng Kèo", href: "/", icon: iconBangKeo },
  { id: "basket", label: "Bóng rổ", href: "/?sport=basketball", iconEmoji: "🏀", sport: "basketball" },
  { id: "tile", label: "Tỉ lệ kèo", href: "/ti-le-keo", icon: iconTiLe },
  { id: "kiemtien", label: "Kiếm Tiền", href: "/kiem-tien", icon: iconKiemTien },
  { id: "nhandinh", label: "Nhận Định", href: "/nhan-dinh", icon: iconNhanDinh },
  { id: "tintuc", label: "Tin Tức", href: "/tin-tuc", icon: iconNews },
  { id: "highlight", label: "Highlight", href: "/xem-highlight", icon: iconHighlight },
  {
    id: "tipthu",
    label: "Tip Thủ",
    href: "/su-kien",
    icon: iconTipThu,
    activePaths: ["/du-doan-bong-da", "/su-kien"],
  },
];

function isNavItemActive(item, pathname, search) {
  const sport = new URLSearchParams(search || "").get("sport");

  if (item.sport === "basketball") {
    return (pathname === "/" && sport === "basketball") || pathname.startsWith("/bong-ro");
  }

  if (item.href === "/") {
    return pathname === "/" && sport !== "basketball";
  }

  if (Array.isArray(item.activePaths) && item.activePaths.length > 0) {
    return item.activePaths.some(
      (path) => pathname === path || pathname.startsWith(`${path}/`)
    );
  }

  const targetPath = item.href.split("?")[0];
  return pathname === targetPath || pathname.startsWith(`${targetPath}/`);
}

export default function HeaderDesktopMenu() {
  const { settings } = useSettings();
  const logoLink = settings?.keo_bong_vip_logo_link || "";
  const [path, setPath] = useState(() =>
    typeof window === "undefined"
      ? { pathname: "/", search: "" }
      : { pathname: window.location.pathname, search: window.location.search }
  );

  useEffect(() => {
    const sync = () =>
      setPath({ pathname: window.location.pathname, search: window.location.search });
    window.addEventListener("popstate", sync);
    return () => window.removeEventListener("popstate", sync);
  }, []);

  return (
    <div className="kbv-hdm">
      <div className="kbv-hdm__inner">
        <div className="kbv-hdm__logo">
          {logoLink ? (
            <img
              src={logoLink}
              alt="logo"
              className="kbv-hdm__logo-img"
              draggable="false"
            />
          ) : null}
        </div>

        <nav className="kbv-hdm__nav hidden lg:flex items-center justify-center gap-2 xl:gap-8 2xl:gap-10 h-full">
          {MENU.map((item) => {
            const isActive = isNavItemActive(item, path.pathname, path.search);

            return (
              <button
                key={item.id}
                type="button"
                className={`kbv-hdm__item group h-[64px] inline-flex items-center gap-2 border-b-2 transition-colors ${
                  isActive
                    ? "kbv-hdm__item--active border-[var(--color-primary)] text-[var(--color-primary)]"
                    : "border-transparent text-white/80 hover:text-[var(--color-primary)]"
                }`}
              >
                {item.iconEmoji ? (
                  <span
                    className="flex h-[18px] w-[18px] shrink-0 items-center justify-center text-[18px] leading-none"
                    aria-hidden
                  >
                    {item.iconEmoji}
                  </span>
                ) : (
                  <img
                    src={item.icon}
                    alt={item.label}
                    width={18}
                    height={18}
                    className="kbv-hdm__icon shrink-0 transition-all duration-200"
                    style={{
                      "--icon-filter": isActive ? ICON_FILTER_ACTIVE : ICON_FILTER_IDLE,
                      "--icon-filter-hover": ICON_FILTER_ACTIVE,
                      filter: "var(--icon-filter)",
                    }}
                    draggable="false"
                  />
                )}
                <span className="text-xs xl:text-base font-semibold whitespace-nowrap">
                  {item.label}
                </span>
              </button>
            );
          })}
        </nav>

        <div className="kbv-hdm__right" aria-hidden />
      </div>
    </div>
  );
}
